"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view() {
    var _this = this;
    return {
        state: {
            showMobileMap: false,
            allowedTags: ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "blockquote", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"]
        },
        initialize: function () {
            _this.props.initMethod();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onSearchClick: this.props.onSearchClick,
            onLocationSearch: this.props.onLocationSearch,
            onLocationSearchChange: this.props.onLocationSearchChange,
            onLocationSearchPredict: this.props.onLocationSearchPredict,
            onLocationSearchSelect: this.props.onLocationSearchSelect,
            onKeywordSearch: this.props.onKeywordSearch,
            onKeywordSearchChange: this.props.onKeywordSearchChange,
            onKeywordSearchPredict: this.props.onKeywordSearchPredict,
            onKeywordSearchSelect: this.props.onKeywordSearchSelect,
            onCreateJobAlert: this.props.onCreateJobAlert,
            onSortSelect: this.props.onSortSelect,
            onSortOpen: this.props.onSortOpen,
            onInfoWindowClick: this.props.onInfoWindowClick,
            toggleMapForMobile: function () {
                _this.view.state.showMobileMap = !_this.view.state.showMobileMap;
            },
            onPageNavigate: this.props.onPageNavigate,
            handleCollapsibleClick: this.props.handleCollapsibleClick,
            onRadioButtonClick: this.props.onRadioButtonClick,
            onCheckboxClick: this.props.onCheckboxClick,
            onInputChange: this.props.onInputChange,
            onDropdownSelect: this.props.onDropdownSelect,
            onShowMobileChecked: this.props.onShowMobileChecked,
            onResetFilters: this.props.onResetFilters,
            onFilterApply: this.props.onFilterApply,
            onFilterCancel: this.props.onFilterCancel,
            onOpenFilterFlyout: this.props.onOpenFilterFlyout,
            onImagesLoaded: this.props.onImagesLoaded,
            setBannerContentHeight: this.props.setBannerContentHeight,
            onCloseJobAlertModal: this.props.onCloseJobAlertModal,
            onJobAlertTitleChange: this.props.onJobAlertTitleChange,
            onJobAlertFrequencyChange: this.props.onJobAlertFrequencyChange,
            onCreateJobAlertBtnClick: this.props.onCreateJobAlertBtnClick,
            onCancelJobAlertCreation: this.props.onCancelJobAlertCreation,
            onCFMainSearchDropdownChange: this.props.onCFMainSearchDropdownChange,
            onFilterFlagCloseClick: this.props.onFilterFlagCloseClick,
            onCloseEmailValidationErrorModal: this.props.onCloseEmailValidationErrorModal
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/.tmp/JobSearch/View.js
// module id = 419
// module chunks = 0